import { Tooltip } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import { FaFilterCircleXmark } from "react-icons/fa6";

export type IconSize = 'large' | "medium" | 'normal' | "small";

interface XmResetFilterIconProps {
  setTableKey: Dispatch<SetStateAction<string>>;
  size?: IconSize;
  disabled?: boolean;
}

export const XmResetFilterIcon: FC<XmResetFilterIconProps> = ({ setTableKey, size = "normal", disabled }) => {
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault()
    if (disabled) return
    setTableKey("" + Math.random())
  }

  return (
    <Tooltip title="Reset all table filters">
      <a
        onClick={handleClick}
        className={disabled ? "disabled" : ""}
        aria-disabled={disabled || undefined}
        data-testid="reset-table-filters"
      >
        <FaFilterCircleXmark className={`xm-icon xm-icon-${size}`} />
      </a>
    </Tooltip>
  )
}

export type { XmResetFilterIconProps as ResetFilterIconProps };

